<template>
	<div class="question-container">
		<div
			v-if="!isBusyCheckingCredit"
			id="social-question"
		>
			<div
				class="question-text"
				v-for="(question, index) in data.question.getQuestion()"
				v-html="question"
				:key="index"
			></div>
			<div
				class="note-text"
				:style="{ color: theme.lightMainTextColor }"
				v-for="(note, index) in data.question.getNotes()"
				v-html="note"
				:key="index + 100"
			></div>
			<div class="input-text">
				<div
					:style="{
						color: v$.textValue.$invalid ? theme.errorInputAccentColor : theme.mainTextColor,
					}"
				>
					<InputMasked
						:onkeypress="data.question.onKeyPressMethod ? util[data.question.onKeyPressMethod]() : util.getOnkeypressNumbersOnlyFormat()"
						:saturn="textValue"
						:invalid="v$.textValue.$invalid"
						:mask="data.question.mask"
						:minlength="data.question.minLength"
						:maxlength="data.question.maxLength"
						type="tel"
						@input="e => handleInput(e, 'textValue')"
						@click="clearIfHashed"
						data-private
						@keyEnter="continueToNextQuestion(isValid)"
					/>
					<!--:autofocus="textValue ? false : true" />-->
				</div>
			</div>
			<div
				v-if="getEstimatedQuote && !data.question.customerApp().dateCompleted"
				id="estimate-quote"
			>
				<button
					class="button btn-text"
					:style="{
						background: theme[getEstimatedQuote.style.background],
						color: theme[getEstimatedQuote.style.text],
					}"
					@click="getEstimatedQuote.actions(null, [null], data.question, toggleLoading)"
				>
					{{ data.question.getLocalizationDisplay(getEstimatedQuote.label, data.language) }}
				</button>
			</div>
		</div>
		<div class="question-continue-button">
			<button
				class="button"
				:style="{
					background: theme[continueBtn.style.background],
					color: theme[continueBtn.style.text],
				}"
				@click="continueBtn.actions(textValue, [], data.question, toggleLoading, saveApplicationAction)"
				:disabled="!data.question.isValidationsMet(continueBtn, v$.textValue)"
			>
				{{ data.question.getLocalizationDisplay(continueBtn.label, data.language) }}
			</button>
		</div>
		<div v-if="isBusyCheckingCredit">loading</div>
	</div>
</template>

<script>
	import util from '@core/services/util';
	import LOCALIZATION from '@core/classes/Localization';
	import InputMasked from '@/components/customerApp/InputMasked.vue';
	import { required, minLength, maxLength, numeric, between } from '@vuelidate/validators';
	import { useVuelidate } from '@vuelidate/core';

	export default {
		name: 'QuestionSocial',
		props: ['theme', 'data', 'questionKey', 'toggleLoading', 'saveApplicationAction'],
		setup() {
			return { v$: useVuelidate({ $scope: false }) };
		},
		data() {
			return {
				isBusyCheckingCredit: false,
				continueBtn: {},
				getEstimatedQuote: {},
				textValue: null,
				isEditing: false,
			};
		},
		computed: {
			localization() {
				return LOCALIZATION;
			},
			util() {
				return util;
			},
			isValid() {
				return this.data.question.isValidationsMet(this.continueBtn, this.v$.textValue);
			},
			//buttonDisabled() {
			//    return this.v$.$invalid
			//}
		},
		async created() {
			this.isEditing = !!this.data.question.savedAnswer;

			this.continueBtn = this.data.question.getAnswers().filter(q => q.label == 'continue')[0];
			// console.log(this.continueBtn)
			this.getEstimatedQuote = this.data.question.getAnswers().filter(q => q.label == 'getEstimatedQuotePerson' || q.label == 'getEstimatedQuoteBusiness')[0];
			this.textValue = this.data.question.savedAnswer;
			this.$watch(
				() => this.data.language,
				newValue => {
					this.data.question.customerApp().quoteAppData.changeLanguage(newValue);
				},
				{ deep: true },
			);
		},

		validations() {
			if (this.data.question.GetValidation && !this.isEditing) {
				return this.data.question.GetValidation();
			} else {
				return {
					textValue: {},
				};
			}
		},
		methods: {
			isHashed() {
				return this.textValue ? this.textValue.startsWith('*****') : false;
			},
			clearIfHashed() {
				if (this.isHashed()) {
					this.textValue = null;
					this.isEditing = false;
				}
			},
			handleInput(value, variable) {
				this[variable] = value;
			},
			continueToNextQuestion(isValid) {
				if (isValid) {
					this.continueBtn.actions(this.textValue, [], this.data.question, this.toggleLoading);
				}
			},
		},
		components: {
			InputMasked,
		},
	};
</script>

<style>
	.btn-text {
		background: none !important;
		padding: 5px;
		text-decoration: underline;
		padding: 10px;
		color: black !important;
		font-size: 15px;
	}

	.note-text {
		margin-top: -20px;
		margin-bottom: 20px;
		font-size: 18px;
	}

	.saturn-textbox .saturn-textbox-error-message {
		display: none;
	}
</style>
